import { NumberInput } from '@lyearn/ui';

export default NumberInput;
